module.exports = __webpack_public_path__ + "img/entryConfig.e7777896.svg";